// apps/client/src/world/objects/bridge.ts — the code-built plank bridge (assets/builders/bridge.ts), static
import type { ObjectView } from '../objectView';

export const view: ObjectView = {
  kinds: ['bridge'],
  async build(obj, ctx) {
    const o = await ctx.assets.model(obj.catalogId);
    o.userData.static = true;
    return o;
  },
};
